<div class="snackbar-container" (click)="onClick()">
  <img
    class="icone"
    width="30"
    height="30"
    [src]="data.type === 'info' ? 'assets/compartilhados/sync.svg' : 'assets/compartilhados/check_circle.svg'"
  />
  <div class="snackbar-content">
    <div class="message-container">
      <span class="primary-text" [ngClass]="{'primary-text-sucesso': data.type === 'sucesso', 'primary-text-info': data.type === 'info'}">
        {{ data.message | transloco }}
      </span>
      <small class="secondary-text">
        {{ data.subtext | transloco }}
      </small>
    </div>
    <mat-progress-bar class="snackbar-progress" [ngClass]="{'snackbar-sucesso': data.type === 'sucesso', 'snackbar-info': data.type === 'info'}"
        mode="determinate"
        [value]="progresso$ | async">
    </mat-progress-bar>
  </div>
</div>